export var GLASSFY_ELEGGIBILITY;
(function (GLASSFY_ELEGGIBILITY) {
    GLASSFY_ELEGGIBILITY[GLASSFY_ELEGGIBILITY["ELEGIBLE"] = 1] = "ELEGIBLE";
    GLASSFY_ELEGGIBILITY[GLASSFY_ELEGGIBILITY["NON_ELEGIBLE"] = -1] = "NON_ELEGIBLE";
    GLASSFY_ELEGGIBILITY[GLASSFY_ELEGGIBILITY["UNKNOWN"] = 0] = "UNKNOWN";
})(GLASSFY_ELEGGIBILITY || (GLASSFY_ELEGGIBILITY = {}));
export var GLASSFY_EVENT_TYPE;
(function (GLASSFY_EVENT_TYPE) {
    GLASSFY_EVENT_TYPE[GLASSFY_EVENT_TYPE["InitialBuy"] = 5001] = "InitialBuy";
    GLASSFY_EVENT_TYPE[GLASSFY_EVENT_TYPE["Restarted"] = 5002] = "Restarted";
    GLASSFY_EVENT_TYPE[GLASSFY_EVENT_TYPE["Renewed"] = 5003] = "Renewed";
    GLASSFY_EVENT_TYPE[GLASSFY_EVENT_TYPE["Expired"] = 5004] = "Expired";
    GLASSFY_EVENT_TYPE[GLASSFY_EVENT_TYPE["DidChangeRenewalStatus"] = 5005] = "DidChangeRenewalStatus";
    GLASSFY_EVENT_TYPE[GLASSFY_EVENT_TYPE["IsInBillingRetryPeriod"] = 5006] = "IsInBillingRetryPeriod";
    GLASSFY_EVENT_TYPE[GLASSFY_EVENT_TYPE["ProductChange"] = 5007] = "ProductChange";
    GLASSFY_EVENT_TYPE[GLASSFY_EVENT_TYPE["InAppPurchase"] = 5008] = "InAppPurchase";
    GLASSFY_EVENT_TYPE[GLASSFY_EVENT_TYPE["Refund"] = 5009] = "Refund";
    GLASSFY_EVENT_TYPE[GLASSFY_EVENT_TYPE["Paused"] = 5010] = "Paused";
    GLASSFY_EVENT_TYPE[GLASSFY_EVENT_TYPE["Resumed"] = 5011] = "Resumed";
    GLASSFY_EVENT_TYPE[GLASSFY_EVENT_TYPE["ConnectLicense"] = 5012] = "ConnectLicense";
    GLASSFY_EVENT_TYPE[GLASSFY_EVENT_TYPE["DisconnectLicense"] = 5013] = "DisconnectLicense";
})(GLASSFY_EVENT_TYPE || (GLASSFY_EVENT_TYPE = {}));
export var GLASSFY_STORE;
(function (GLASSFY_STORE) {
    GLASSFY_STORE[GLASSFY_STORE["AppStore"] = 1] = "AppStore";
    GLASSFY_STORE[GLASSFY_STORE["PlayStore"] = 2] = "PlayStore";
    GLASSFY_STORE[GLASSFY_STORE["Paddle"] = 3] = "Paddle";
    GLASSFY_STORE[GLASSFY_STORE["Stripe"] = 4] = "Stripe";
    GLASSFY_STORE[GLASSFY_STORE["Glassfy"] = 5] = "Glassfy";
})(GLASSFY_STORE || (GLASSFY_STORE = {}));
export var GLASSFY_LOGLEVEL;
(function (GLASSFY_LOGLEVEL) {
    GLASSFY_LOGLEVEL[GLASSFY_LOGLEVEL["OFF"] = 0] = "OFF";
    GLASSFY_LOGLEVEL[GLASSFY_LOGLEVEL["ERROR"] = 1] = "ERROR";
    GLASSFY_LOGLEVEL[GLASSFY_LOGLEVEL["DEBUG"] = 2] = "DEBUG";
    GLASSFY_LOGLEVEL[GLASSFY_LOGLEVEL["INFO"] = 3] = "INFO";
    GLASSFY_LOGLEVEL[GLASSFY_LOGLEVEL["ALL"] = 3] = "ALL";
})(GLASSFY_LOGLEVEL || (GLASSFY_LOGLEVEL = {}));
export var GLASSFY_ATTRIBUTION;
(function (GLASSFY_ATTRIBUTION) {
    GLASSFY_ATTRIBUTION[GLASSFY_ATTRIBUTION["AdjustID"] = 1] = "AdjustID";
    GLASSFY_ATTRIBUTION[GLASSFY_ATTRIBUTION["AppsFlyerID"] = 2] = "AppsFlyerID";
    GLASSFY_ATTRIBUTION[GLASSFY_ATTRIBUTION["IP"] = 3] = "IP";
    GLASSFY_ATTRIBUTION[GLASSFY_ATTRIBUTION["IDFA"] = 4] = "IDFA";
    GLASSFY_ATTRIBUTION[GLASSFY_ATTRIBUTION["IDFV"] = 5] = "IDFV";
    GLASSFY_ATTRIBUTION[GLASSFY_ATTRIBUTION["GAID"] = 6] = "GAID";
    GLASSFY_ATTRIBUTION[GLASSFY_ATTRIBUTION["ASID"] = 7] = "ASID";
    GLASSFY_ATTRIBUTION[GLASSFY_ATTRIBUTION["AID"] = 8] = "AID";
})(GLASSFY_ATTRIBUTION || (GLASSFY_ATTRIBUTION = {}));
export var GLASSFY_PRORATION_MODE;
(function (GLASSFY_PRORATION_MODE) {
    GLASSFY_PRORATION_MODE[GLASSFY_PRORATION_MODE["UNKNOWN_SUBSCRIPTION_UPGRADE_DOWNGRADE_POLICY"] = 0] = "UNKNOWN_SUBSCRIPTION_UPGRADE_DOWNGRADE_POLICY";
    GLASSFY_PRORATION_MODE[GLASSFY_PRORATION_MODE["IMMEDIATE_WITH_TIME_PRORATION"] = 1] = "IMMEDIATE_WITH_TIME_PRORATION";
    GLASSFY_PRORATION_MODE[GLASSFY_PRORATION_MODE["IMMEDIATE_AND_CHARGE_PRORATED_PRICE"] = 2] = "IMMEDIATE_AND_CHARGE_PRORATED_PRICE";
    GLASSFY_PRORATION_MODE[GLASSFY_PRORATION_MODE["IMMEDIATE_WITHOUT_PRORATION"] = 3] = "IMMEDIATE_WITHOUT_PRORATION";
    GLASSFY_PRORATION_MODE[GLASSFY_PRORATION_MODE["DEFERRED"] = 4] = "DEFERRED";
    GLASSFY_PRORATION_MODE[GLASSFY_PRORATION_MODE["IMMEDIATE_AND_CHARGE_FULL_PRICE"] = 5] = "IMMEDIATE_AND_CHARGE_FULL_PRICE";
})(GLASSFY_PRORATION_MODE || (GLASSFY_PRORATION_MODE = {}));
export var GLASSFY_ENTITLEMENT;
(function (GLASSFY_ENTITLEMENT) {
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["NEVERBUY"] = -9] = "NEVERBUY";
    // The customer received a refund for the subscription.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["OTHERREFUND"] = -8] = "OTHERREFUND";
    // The customer received a refund due to a perceived issue with the app.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["ISSUEREFUND"] = -7] = "ISSUEREFUND";
    // The system canceled the subscription because the customer upgraded.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["UPGRADED"] = -6] = "UPGRADED";
    // The customer intentionally cancelled the subscription.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["EXPIREDVOLUNTARY"] = -5] = "EXPIREDVOLUNTARY";
    // The product is no longer available.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["PRODUCTNOTAVAILABLE"] = -4] = "PRODUCTNOTAVAILABLE";
    // The customer did not accept the price increase.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["FAILTOACCEPTINCREASE"] = -3] = "FAILTOACCEPTINCREASE";
    // The receipt is fully expired due to a billing issue.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["EXPIREDFROMBILLING"] = -2] = "EXPIREDFROMBILLING";
    // The receipt is expired but the subscription is still in a billing-retry state.
    // If grace period is enabled this state excludes subscriptions in grace period.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["INRETRY"] = -1] = "INRETRY";
    // The receipt is out of date or there is another purchase issue.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["MISSINGINFO"] = 0] = "MISSINGINFO";
    // The subscription expired but is in grace period.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["EXPIREDINGRACE"] = 1] = "EXPIREDINGRACE";
    // The subscription is an off-platform subscription.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["OFFPLATFORM"] = 2] = "OFFPLATFORM";
    // The subscription is a non-renewing subscription.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["NONRENEWING"] = 3] = "NONRENEWING";
    // The subscription is active and auto-renew is off.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["AUTORENEWOFF"] = 4] = "AUTORENEWOFF";
    // The subscription is active and auto-renew is on.
    GLASSFY_ENTITLEMENT[GLASSFY_ENTITLEMENT["AUTORENEWON"] = 5] = "AUTORENEWON";
})(GLASSFY_ENTITLEMENT || (GLASSFY_ENTITLEMENT = {}));
//# sourceMappingURL=definitions.js.map